// `version` is patched by the publish workflow to the release tag before the production build.
// It stays 25.0.0 in the repository, so a locally built frontend reports 25.0.0 on purpose.
export const environment = {
  production: true,
  version: '25.0.36'
};
